import { AxiosRequestConfig } from "axios";

import axiosInstance from "@/v2/libs/axios/config";

// (GET, POST, PUT, DELETE)
const getRequest = async <T>(
  url: string,
  config: AxiosRequestConfig = {},
): Promise<T> => {
  const response = await axiosInstance.get(url, config);
  return response.data;
};

const postRequest = async <T, D>(
  url: string,
  data?: D,
  config: AxiosRequestConfig = {},
): Promise<T> => {
  const response = await axiosInstance.post(url, data, config);

  if (response.status !== 200) {
    throw new Error("Network response was not ok");
  }

  return response.data;
};

const putRequest = async <T, D>(
  url: string,
  data: D,
  config: AxiosRequestConfig = {},
): Promise<T> => {
  const response = await axiosInstance.put(url, data, config);
  return response.data;
};

const deleteRequest = async <T>(
  url: string,
  config: AxiosRequestConfig = {},
): Promise<T> => {
  const response = await axiosInstance.delete(url, config);
  return response.data;
};

// Exporting
export { getRequest, postRequest, putRequest, deleteRequest };
